const Server = (link, result, handler) => {
    const queryString = Object.entries(result).map(([key, value]) => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    }).join('&');

    fetch(link, {
        method: "post",
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body: queryString
    }).then(function(response) {
        return response.json();
    }).then(function(data) {
        if (data.result && !data.error) {
            handler('success');
        } else {
            handler('error');
        }
    }).catch(function(error) {
        handler('retry');
    });
}

export default Server;